module.exports = __webpack_public_path__ + "img/603ea9e.jpg";